import React, { memo } from "react";
import { CardNotification, Heading, Text } from "@foris/avocado-suite";
import { AdaptedGroup, GroupEditionErrors } from "../../models";
import messageByGroupEditionError from "../../utils/messageByGroupEditionError";
import css from "./bottomWarnings.module.scss";

interface Props {
  errorsByGroupId: Record<AdaptedGroup["id"], GroupEditionErrors>;
  groupsById: Record<AdaptedGroup["id"], AdaptedGroup>;
}

const BottomWarnings: React.FC<Props> = ({ errorsByGroupId, groupsById }) => {
  const title = () => {
    const length = Object.keys(errorsByGroupId)?.length;
    if (length === 1) return "1 Grupo con alertas";
    else return `${length} Grupos con alertas`;
  };

  return (
    <CardNotification className={css.errors} state="warning" title={title()} outlined>
      <div className={css.groups}>
        {Object.keys(errorsByGroupId)?.map((groupId: string) => {
          const errors = errorsByGroupId[groupId];
          return (
            <div key={groupId}>
              <Heading
                type="h4"
                className={css.error_title}
              >{`Grupo ${groupsById[groupId]?.code}`}</Heading>
              {Object.keys(errors)?.map(error => (
                <Text key={`${groupId}-${error}`} className={css.error_message}>
                  {messageByGroupEditionError(error as keyof GroupEditionErrors)?.verbose}
                </Text>
              ))}
            </div>
          );
        })}
      </div>
    </CardNotification>
  );
};

export default memo(BottomWarnings);
